import * as React from 'react';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { Password, ValidationProps, createValidationErrors } from 'ui';

interface ChangePasswordComponentProps {
  onClose: () => void;
  setPassword: (password: string) => void;
  validation: ValidationProps;
  clearValidation: (fieldName: string) => void;
  textTitle: string;
  textPassword: string;
  textConfirmPassword: string;
  textDoneButton: string;
  textCancel: string;
  textMustBeEqual: string;
  textPasswordHint?: string;
  fetching: boolean;
  maxLength: number;
}

interface ChangePasswordComponentState {
  password: string;
  confirmedPassword: string;
  confirmedPasswordValidation: ValidationProps;
}

class ChangePasswordComponent extends React.Component<ChangePasswordComponentProps, ChangePasswordComponentState> {
  public state: Readonly<ChangePasswordComponentState> = {
    password: '',
    confirmedPassword: '',
    confirmedPasswordValidation: undefined
  };

  public componentDidMount() {
    this.clearValidation();
  }

  private handlePasswordChange = (value: string) => {
    this.setState({
      password: value
    });
    this.clearValidation();
  };
  private handleConfirmedPasswordChange = (value: string) => {
    this.setState({
      confirmedPassword: value,
      confirmedPasswordValidation: undefined
    });
  };

  private clearValidation = () => {
    if (!!this.props.validation) {
      this.props.clearValidation('password');
    }
  };

  private handleDone = () => {
    this.clearValidation();
    if (this.state.password === this.state.confirmedPassword) {
      this.setState({
        confirmedPasswordValidation: undefined
      }, () => {
        this.props.setPassword(this.state.password);
      });
    } else {
      this.setState({
        confirmedPasswordValidation: createValidationErrors([this.props.textMustBeEqual])
      });
    }
  };

  public render() {
    const { validation, onClose } = this.props;
    const { textTitle, textPassword, textConfirmPassword, textDoneButton, textCancel, textPasswordHint,
      fetching, maxLength } = this.props;

    return (<ModalWrapper
      headerTitle={textTitle}
      btnTitle={textDoneButton}
      btnCancelTitle={textCancel}
      onClose={onClose}
      onDone={this.handleDone}
      closeOnDone={false}
      canCloseOnBackground={false}
      largeSize={false}
      isDisabled={fetching}>
      <Password
        componentId={'password'}
        onChange={this.handlePasswordChange}
        className={''}
        label={{ text: textPassword, required: true }}
        value={this.state.password}
        validation={validation}
        info={{ text: textPasswordHint, visible: !!textPasswordHint }}
        maxLength={maxLength} />
      <Password
        componentId={'confirmedPassword'}
        onChange={this.handleConfirmedPasswordChange}
        className={''}
        label={{ text: textConfirmPassword, required: true }}
        value={this.state.confirmedPassword}
        validation={this.state.confirmedPasswordValidation}
        maxLength={maxLength} />
    </ModalWrapper>);
  }
}

export const ChangePassword = ChangePasswordComponent;
